export default "__VITE_ASSET__BZZr491p__"